import { render, staticRenderFns } from "./SelectedLocationsSummary.vue?vue&type=template&id=65bf1a5c&scoped=true"
import script from "./SelectedLocationsSummary.vue?vue&type=script&lang=ts"
export * from "./SelectedLocationsSummary.vue?vue&type=script&lang=ts"
import style0 from "./SelectedLocationsSummary.vue?vue&type=style&index=0&id=65bf1a5c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bf1a5c",
  null
  
)

export default component.exports